(function () {
  //numbers block
  const digits = document.querySelectorAll('.digits');
  if (digits.length > 0) {
    const isInViewport = function (elem) {
      var distance = elem.getBoundingClientRect();
      return (
        distance.top >= 0 &&
        distance.left >= 0 &&
        distance.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        distance.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    };
    digits.forEach((element) => {
      if (!element.classList.contains('count'))
        if (isInViewport(element)) {
          element.classList.add('count');
          element.style.setProperty('--number', element.dataset.number);
        }
    });

    window.addEventListener('scroll', function (event) {
      digits.forEach((element) => {
        if (!element.classList.contains('count'))
          if (isInViewport(element)) {
            element.classList.add('count');
            element.style.setProperty('--number', element.dataset.number);
          }
      });
    });
  }

  //category page
  const subnavHeader = document.querySelector('.subnav .subnav__header');
  if (subnavHeader) {
    subnavHeader.addEventListener('click', function (e) {
      const subnav = e.target.closest('.subnav');
      subnav.classList.toggle('show');
    });
  }
})();
